<template>
  <div>
    <div class="title-and-button">
      <!-- 标题 -->
      <span class="title">{{ title }}</span>
      <!-- 按钮 -->
      <el-link v-if="showButtom"
               class="title-button-style"
               @click="titleButtonClick"
               :underline="false"
               type="info"
               icon="el-icon-edit">{{buttonName}}</el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'input-modify',
  data() {
    return {
      info: '',
      is_editor: '',
      save_visable_prop: this.save_visable,
      show_input_prop: this.show_editor,
      show_content_visable_prop: this.show_content_visable,
      // 输入组件
      input_textarea_width: '300px',
      input_text: this.show_content,
      input_textares: '',
      content: this.show_content,
      editor_content: '', //编辑器内容
    }
  },
  props: {
    title: String,
    show_content: String, //动态绑定显示的内容
    attribuite: Number,
    buttonName: String, // 按钮名称
    // 样式
    // input_width: String,
    type: String,
    showButtom: {
      type: Boolean,
      default: true,
    },
    save_visable: {
      type: Boolean,
      default: false,
    },
    show_editor: {
      type: Boolean,
      default: false,
    },
    show_content_visable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    // 复制文本信息pastContent
    pastContent(event) {
      // console.log(event.target.innerHTML);
      this.$copyText(event.target.innerHTML).then((res) => {
        this.$message({
          message: '信息已复制到剪贴板',
          type: 'success',
        })
      })
    },
    // 监听按钮
    titleButtonClick() {
      this.$emit('titleButtonClick')
    },
  },
}
</script>

<style>
.title-and-button {
  border-left: 5px solid #ff5420;
  padding: 0 5px;
}
/* .title-and-input:hover .input-button-style {
  display: block;
} */
.title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 10px;
}
.edito_save_right {
  /* cursor: pointer; */
}
.input {
  margin-left: 10px;
}

.title-button-style {
  /* display: none; */
  float: right;
  font-size: 10px;
}

/* v-bind 绑定两种class */
.class_name_one {
  width: 100px;
}
.class_name_two {
  width: 300px;
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>